/**
 * 描述：图片素材左侧导航
 * 日期：2017-8-22
 * 作者：Bai.Zhiming
 */
'use strict';
angular.module('resCenClassifiedPictureLeftModule', [])
    .directive('classifiedPictureLeft', ['$q', '$state', '$stateParams', 'trsHttpService', function ($q, $state, $stateParams, trsHttpService) {
        return {
            replace: false,
            restrict: 'E',
            templateUrl: './networkResource/classifiedResource/picture/left/left_tpl.html',
            scope: {},
            link: function ($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.status = {};
                    $scope.data = {};
                }

                /**
                 * [initData description] 初始化数据
                 * @return {[type]} [description]
                 */
                function initData() {
                    getLeftList().then(function (data) {
                        autoLocation();
                    });
                }

                /**
                 * [autoLocation description] 自动定位
                 * @return {[type]} [description]
                 */
                function autoLocation() {
                    var flag = false;
                    for (var i in $scope.data.treeData) {
                        var data = $scope.data.treeData[i];
                        if (data.id === $stateParams.nodeid) {
                            flag = true;
                            $scope.status.isSelected = data;
                            break;
                        } else {
                            for (var j in data.CHILDLIST) {
                                var child = data.CHILDLIST[j];
                                if (child.id === $stateParams.nodeid) {
                                    flag = true;
                                    $scope.status.isSelected = child;
                                    $scope.status.isSelectedParent = data;
                                    break;
                                }
                            }
                        }
                    }
                    if (!flag) {
                        goTo($scope.data.treeData[0]);
                    }
                }

                /**
                 * [getLeftList description] 获取左侧列表
                 * @return {[type]} [description]
                 */
                function getLeftList() {
                    var deffer = $q.defer();
                    var params = {
                        channelName: 'tpg',
                        containParent: false,
                        excludeId: -1,
                        level: 2,
                        modelid: 'base',
                        parentId: -1,
                        serviceid: 'navigation',
                        typeName: 'tp_lyzh',
                        typeid: 'zyzx'
                    };
                    trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function (data) {
                        for (var i = data.length - 1; i >= 0; i--) {
                            data[i].CHILDLIST = data[i].CHILDLIST !== undefined ? data[i].CHILDLIST : [];
                            data[i].ID = data[i].id !== undefined ? data[i].id : '';
                        }
                        $scope.data.treeData = data;
                        deffer.resolve(data);
                    });
                    return deffer.promise;
                }

                /**
                 * [firstClick description] 选中节点
                 * @param   {[type]}  event  [event description]
                 * @param   {[type]}  node   [node description] 所选节点
                 * @return  {[type]}         [return description]
                 */
                $scope.firstClick = function (event, node) {
                    if (event.stopPropagation) {
                        event.stopPropagation();
                    }
                    goTo(node);
                };

                /**
                 * [secondClick description] 点击二级节点
                 * @param   {[type]}  event  [event description]
                 * @param   {[type]}  item   [item description]
                 * @param   {[type]}  items  [items description]
                 * @return  {[type]}         [return description]
                 */
                $scope.secondClick = function (event, item, items) {
                    event.stopPropagation();
                    $scope.status.isSelectedParent = items;
                    goTo(item);
                };

                /**
                 * [goTo description] 页面跳转
                 * @param   {[type]}  node  [node description]
                 * @return  {[type]}        [return description]
                 */
                function goTo(node) {
                    $scope.status.isSelected = node;
                    $state.go('front.networksource.classifiedresource.picture.resource', {
                        typename: 'tp_lyzh',
                        nodeid: node.id,
                        nodename: node.dictName,
                        change: Math.random(0, 1) * 100,
                        medianame: node.dictName,
                    }, { reload: 'front.networksource.classifiedresource.picture.resource' });
                }

                /**
                 * [expandNode description] 展开和选中样式
                 * @param   {[type]}  event  [event description]
                 * @param   {[type]}  items  [items description]
                 * @return  {[type]}         [return description]
                 */
                $scope.expandNode = function (event, items) {
                    event.stopPropagation();
                    items.isOpen = !items.isOpen;
                };
            }
        };
    }]);
